<template>
   <div
    ref="container"
    class="flex justify-center items-center origin-top-left !pointer-events-none"
    :class="$style.container"
    :style="{ transform: `scale(${scaleFactor})` }">
    <component
      :is="widgetComponent"
      class="!pointer-events-none is-editor"
      :widget="formattedWidget"
      :target-step-index="targetStepIndex"/>
  </div>
</template>

<script>
import ColumnWidgetComponent from '@components/Widgets/ColumnWidget/ColumnStepPreview/ColumnStepPreview.vue'
import ImageColumnStepPreview
  from '@components/Widgets/ImageColumnWidget/ImageColumnStepPreview/ImageColumnStepPreview.vue'
import FortuneWheelStepPreview
  from '@components/Widgets/FortuneWheelWidget/FortuneWheelStepPreview/FortuneWheelStepPreview.vue'
import { formatWidgetForApi } from '@utils/formatWidgetApi'
import _debounce from 'lodash/debounce'

export default {
  name: 'WidgetStepPreview',
  components: {
    ColumnWidgetComponent,
    ImageColumnStepPreview,
    FortuneWheelStepPreview,
  },
  props: {
    widget: {
      required: true,
      type: Object,
    },
    targetStepIndex: {
      required: false,
      type: Number,
      default: 0,
    },
    needsReformatting: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scaleFactor: 1,
    };
  },
  computed: {
    formattedWidget() {
      return this.needsReformatting ? formatWidgetForApi(this.widget) : this.widget;
    },
    widgetComponent() {
      if (!this.widget) return null;

      const typeComponentMap = {
        column: 'ColumnWidgetComponent',
        imageColumn: 'ImageColumnStepPreview',
        fortuneWheel: 'FortuneWheelStepPreview',
      };

      return typeComponentMap[this.widget.type] || null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateScaleFactor();
    })

    // Update the scale factor when the window is resized
    this.debouncedUpdateScaleFactor = _debounce(this.updateScaleFactor, 100);
    window.addEventListener('resize', this.debouncedUpdateScaleFactor);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedUpdateScaleFactor);
  },
  methods: {
    updateScaleFactor() {
      // Get the width of the parent element
      const parentWidth = this.$el.parentNode.clientWidth;

      const minWidth = 1024;

      // Calculate the scale factor
      let scale = parentWidth / minWidth;

      // Ensure the scale does not exceed 1 (original size)
      if (scale > 1) {
        scale = 1;
      }

      this.scaleFactor = scale;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  min-width: 1024px;
  min-height: 620px;
  //transform: scale(0.12);
}
</style>